import { jwtDecode } from 'jwt-decode';

export const getJwt = () => {
  const token = localStorage.getItem('user_jwt');

  if (!token || isTokenExpired(token)) {
    localStorage.removeItem('user_jwt');

    return null;
  }


  return token;
};

let cachedToken = null;
let cachedDecoded = null;

export const getDecodedJwt = () => {
  const token = getJwt();

  if (token !== cachedToken) {
    try {
      cachedDecoded = jwtDecode(token);
      cachedToken = token;
    } catch {
      cachedDecoded = null;
    }
  }
  return cachedDecoded;
};

export const getUser = () => {
  try {
    const decoded = getDecodedJwt();
    return decoded.sub || null;
  } catch (error) {
    console.error('Invalid JWT:', error);
    return null;
  }
};

export const hasPermission = (permission) => {
  const token = getJwt();
  if (!token) return false;

  try {
    const decoded = getDecodedJwt();
    const perms = decoded.auth || '';

    if (!perms) return false;
    return perms.split(',').includes(permission);
  } catch (error) {
    console.error('Invalid JWT:', error);
    return false;
  }
};

export const isTokenExpired = (token) => {
  try {
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 < Date.now();
  } catch (e) {
    return true; // Treat invalid token as expired
  }
};


export const hasMainPanelAlarmStatusChange = () => {
  return true;
};

export const hasMainPanelEventReadChange = () => {
  return hasPermission('DASHBOARD_CHANGE');
};

export const hasMainPanelTaskStatusChange = () => {
  return hasPermission('DASHBOARD_CHANGE');
};
export const hasWrite = () => {
  return hasPermission('WRITE');
};

export const hasRead = () => {
  return hasPermission('APPLICATION_READ');
};


export const authHeader = () => {
  if (!getJwt()) {
    return {};
  }

  return { headers: { Authorization: `Bearer ${getJwt()}` } };
};

export const paramsSerializer = (params) => {
  return Object.entries(params).map(([key, value]) => `${key}=${value}`).join('&');
};